import React from 'react';
import { useParameter } from '../../../shared';

export function useResetBusinessUnit() {
  const [business, setBusiness] = useParameter<number>("@business-units");
  const defaultBusiness = React.useMemo(() => business, []);
  React.useEffect(() => {
    return () => {
      setBusiness(defaultBusiness || null);
    }
  }, []);
}